import {
  MockMap,
  utils,
} from '@ama-sdk/core';
import {
  Email,
  Journey,
  JourneyElementCommon,
  Phone,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  combineJourneys,
  createJourney,
  createJourneyTraveler,
  createMockData,
  createMockDataWithResponse,
  RecursivePartial,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  authorization,
} from '../../mock';
import {
  chargeableSeatsToPayForMultiLegJourney,
  defaultCheckInBaggagePolicies,
  etktAndFFBoardingPassResult,
  firstCHSeatOnMultiLegJourney,
  multiLegExitRowChargeableSeatsUpdateResponse,
  multiLegSameChargeableSeatsUpdateResponse,
  noItemToPayError,
  paymentRecords,
} from '../../mock/data';
import {
  globalDob,
} from '../../mock/dictionaries/dates';
import {
  overrideSeatmapAvailability,
  retrieveSeatMapsJourneyDriven,
} from './common/seatmap';

const email: Email = {
  id: 'email-id',
  address: 'christophe.bernard@amadeus.com',
  category: 'personal',
  contactType: 'Email',
  purpose: 'notification'
};

const phone: Phone = {
  id: 'phone-id',
  number: '+33123456789',
  category: 'personal',
  contactType: 'Phone',
  purpose: 'information'
};

const journeyTemplate: RecursivePartial<Journey> = {
  contacts: [email, phone],
  travelers: [
    createJourneyTraveler({
      template: {
        dateOfBirth: new utils.Date(globalDob),
        gender: 'male',
        names: [
          {
            firstName: 'TEST',
            lastName: 'BERNARD',
            title: 'MR'
          }
        ]
      }
    })
  ]
};

const journeys = combineJourneys([journeyTemplate]).items;
const journeyElementIds = journeys[0].journeyElements.map((je: JourneyElementCommon) => je.id);
const travelerIdList = journeys[0].travelers.map((t) => t.id).filter((id): id is string => !!id);
let seatmap = retrieveSeatMapsJourneyDriven(journeys[0], travelerIdList);
seatmap = overrideSeatmapAvailability(seatmap, travelerIdList, [
  {
    seatNumber: '1A', // chargeable exit row seat
    status: 'available',
    isExitRow: true
  },
  {
    seatNumber: '10A', // chargeable exit row seat
    status: 'available',
    isExitRow: true
  }]
);

/**
 * OW 1Journey
 * 1ADT
 * No baggage
 */
export const ow1Journey1AdtExitRowRetrieve: MockMap = {
  assignSeatToJourneyElement: [
    createMockDataWithResponse(firstCHSeatOnMultiLegJourney[0], 201)
  ],
  generateBoardingPasses: [createMockDataWithResponse(combineBoardingPassResults(etktAndFFBoardingPassResult, {
    journeyElementIds
  }).items, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies([defaultCheckInBaggagePolicies]).items)],
  getJourneyUnpaidItems: [
    createMockData(chargeableSeatsToPayForMultiLegJourney),
    createMockData(noItemToPayError)
  ],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [createMockDataWithResponse(journeys, 201), createMockDataWithResponse([{
    ...journeys[0],
    acceptance: AcceptanceRepository.ACCEPTED
  }], 201)],
  retrieveJourney: [
    createMockData(
      createJourney({
        template: {
          ...journeys[0],
          acceptance: AcceptanceRepository.ACCEPTED
        }
      })
    )
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)],
  authorizeJourneyPaymentRecord: [createMockData(authorization)],
  confirmJourneyPaymentRecord: [createMockData(paymentRecords)],
  createJourneyPaymentRecord: [createMockData(paymentRecords)],
  updateJourneySeats: [
    createMockData(multiLegExitRowChargeableSeatsUpdateResponse, undefined),
    createMockData(multiLegSameChargeableSeatsUpdateResponse)
  ],
  updateJourneyElement: [
    createMockData(multiLegExitRowChargeableSeatsUpdateResponse, undefined),
    createMockData(multiLegSameChargeableSeatsUpdateResponse)
  ]
};
